(function () {
    class SimpleCalendarSelectorElement extends HTMLElement {

        static get observedAttributes() {
            return ['month', 'year', 'day', 'locale', 'display'];
        }

        constructor() {
            super();
            this.hasInitiated = false;

            this.addEventListener('click', (e) => {
                let tag = e.target.tagName == "A" ? e.target : e.target.closest("a");

                if (tag && tag.tagName == "A" && tag.hasAttribute('data-calendar-selector')) {
                    let dataLink = tag.getAttribute('data-calendar-selector');

                    if (dataLink == "years") {
                        e.preventDefault();
                        this.state = "year";
                        this.buildSelector();
                    } else if (dataLink == "month") {
                        // e.preventDefault();

                        // this.calendar.buildCalendar();
                        this.calendar.preventDateEventDispatch = true;

                        this.calendar.dispatchEvent(new CustomEvent('dateChange', {
                            date: this.pendingChange
                        }));

                        let year = this.getYear();
                        this.pendingChange = [year, tag.getAttribute("href").replace("#", "")];

                        this.removeAttribute("display");
                        this.calendar.setAttribute("year", this.pendingChange[0]);
                        this.calendar.setAttribute("month", this.pendingChange[1]);
                        this.setAttribute("year", this.pendingChange[0]);
                        this.setAttribute("month", this.pendingChange[1]);

                        this.calendar.preventDateEventDispatch = false;
                    }
                    // else if ( dataLink == "day" ) {
                    //     e.preventDefault();
                    //     this.state = "day";
                    //     this.buildSelector();     

                    //     this.calendar.preventDateEventDispatch = true;

                    //     this.calendar.dispatchEvent(new CustomEvent('dateChange', {
                    //         date: this.pendingChange
                    //     }));

                    //     let year = this.getYear();
                    //     this.pendingChange = [ year, tag.getAttribute("href").replace("#", "") ];

                    //     // this.removeAttribute("display");
                    //     this.calendar.setAttribute( "year", this.pendingChange[0] );
                    //     this.calendar.setAttribute( "month", this.pendingChange[1] );
                    //     this.setAttribute( "year", this.pendingChange[0] );
                    //     this.setAttribute( "month", this.pendingChange[1] );
                    //     console.log("test month", this.pendingChange);

                    //     this.calendar.preventDateEventDispatch = false;

                    //     console.log(this.getMonth());
                    // } 
                    // else if (dataLink == 'select-day') {
                    //     this.calendar.preventDateEventDispatch = false;

                    //     // this.calendar.dispatchEvent(new CustomEvent('dateChange', {
                    //     //     date: this.pendingChange
                    //     // }));

                    //     let year = this.getYear();
                    //     let month = this.getMonth();

                    //     this.pendingChange = [ year, month, tag.getAttribute("href").replace("#", "") ];

                    //     this.removeAttribute("display");
                    //     this.setAttribute( "year", this.pendingChange[0] );
                    //     this.setAttribute( "month", this.pendingChange[1] );
                    //     this.setAttribute( "day", this.pendingChange[2] );
                    //     this.calendar.setAttribute( "year", this.pendingChange[0] );
                    //     this.calendar.setAttribute( "month", this.pendingChange[1] );
                    //     this.calendar.setAttribute( "day", this.pendingChange[2] );

                    //     console.log(this.getAttribute('day'));

                    // } 
                    else if (dataLink == "year-left") {
                        e.preventDefault();
                        if (this.getYear() - 1 >= this.calendar.getMinYear()) {
                            this.setAttribute("year", this.getYear() - 1);
                            this.buildSelector();
                        }
                    } else if (dataLink == "year-right") {
                        e.preventDefault();
                        if (this.getYear() + 1 <= this.calendar.getMaxYear()) {
                            this.setAttribute("year", this.getYear() + 1);
                            this.buildSelector();
                        }
                    } else if (dataLink == "year-range-left") {
                        e.preventDefault();
                        this.yearRangePosition -= 1;
                        this.buildSelector();
                    } else if (dataLink == "year-range-right") {
                        e.preventDefault();
                        this.yearRangePosition += 1;
                        this.buildSelector();
                    } else if (dataLink == "year") {
                        e.preventDefault();
                        this.state = "month";
                        this.setAttribute("year", tag.getAttribute("href").replace("#", ""));
                    }
                }
            });
        }

        connectedCallback() {
            let THIS = this;

            this.calendar = this.getConnectedCalendar();

            this.setDefault();

            this.calendar.addEventListener("selector--open", function () {
                THIS.setAttribute('display', '');
            });

            this.calendar.addEventListener("selector--close", function () {
                THIS.removeAttribute('display');
            });

            // These functions are universal, just moving them into our scope
            this.builder = this.calendar.builder;
            this.parseTemplate = this.calendar.parseTemplate;

            this.buildSelector();
            this.hasInitiated = true;
        }

        setDefault() {
            this.yearRangePosition = 0;
            this.yearRangeShow = 9;
            this.yearRangeMidpoint = 5;
            this.pendingChange = false;

            this.state = "month";

            this.setAttribute("year", this.calendar.getYear());
            this.setAttribute("month", this.calendar.getMonth());
        }

        attributeChangedCallback(attrName, oldVal, newVal) {
            if (this.hasInitiated) {
                if (attrName == "display") {
                    // fallback for when someone sets the attribute to false
                    if (newVal == "false") {
                        this.removeAttribute("display");
                        return;
                    } else if (newVal == null) {
                        this.calendar.dispatchEvent(new CustomEvent('dateSelectorClose', {}));
                        return;
                    } else {
                        this.setDefault();
                        this.calendar.dispatchEvent(new CustomEvent('dateSelectorOpen', {}));
                    }
                }

                this.buildSelector();
            }
        }

        buildSelector() {
            if (this.hasAttribute('display')) {
                let dom = {
                    yearSelector: '',
                    monthSelector: '',
                    daySelector: ''
                };

                if (this.state == "year") {
                    dom.yearSelector = this.generateYearSelector();
                }

                if (this.state == "month") {
                    dom.monthSelector = this.generateMonthSelector();
                }

                // if ( this.state == "day" ) {
                //     dom.monthSelector = this.generateDaySelector();
                // }

                // console.log(dom);
                this.builder(this, this.parseTemplate('selector', dom));
            }
        }

        // generateDaySelector( returnable = 'html' ) {
        //     let result = returnable == 'json' ? [] : '';
        //     let year = this.getYear(), month = this.getMonth(), day = this.getDay();

        //     let date = moment( [year, month] );
        //     let days = Array.from(Array(moment().daysInMonth()), (_, i) => i + 1);


        //     if ( returnable == "json" ) {
        //         result.push({
        //             date: date,
        //             calendar: this.calendar,
        //             days: days
        //         });
        //     } else {
        //         result += this.parseTemplate( 'selector-days', {
        //             date: date,
        //             calendar: this.calendar,
        //             days: days,
        //             this: this
        //         });
        //     }

        //     return result;
        // }

        generateMonthSelector(returnable = 'html') {
            let result = returnable == 'json' ? [] : '';
            let year = this.getYear(), month = this.getMonth();

            let date = moment([year, month]);
            let monthFormat = { long: moment.months(), short: moment.monthsShort() };

            if (returnable == "json") {
                result.push({
                    date: date,
                    calendar: this.calendar,
                    months: monthFormat
                });
            } else {
                result += this.parseTemplate('selector-months', {
                    date: date,
                    calendar: this.calendar,
                    months: monthFormat,
                    this: this
                });
            }

            return result;
        }

        generateYearSelector(returnable = 'html') {
            let result = returnable == 'json' ? [] : '';
            let year = this.getYear();
            let minYear = this.calendar.getMinYear();
            let maxYear = this.calendar.getMaxYear();

            let yearRangeShow = this.yearRangeShow;
            let yearRangeMidpoint = this.yearRangeMidpoint;
            let yearRangePosition = this.yearRangePosition;
            var isMinYear = false, isMaxYear = false;

            let minYearCondition = minYear && minYear > year - yearRangeMidpoint + (yearRangePosition * yearRangeShow);
            let maxYearCondition = maxYear && maxYear <= year - yearRangeMidpoint + (yearRangePosition * yearRangeShow) + yearRangeShow;

            if (minYearCondition && maxYearCondition) {
                yearRangeShow = maxYear - minYear;
                yearRangeMidpoint = 0;
                yearRangePosition = 0;
                isMinYear = true;
                isMaxYear = true;
                year = minYear;
            } else if (minYearCondition) {
                year = minYear + yearRangeMidpoint - (yearRangePosition * yearRangeShow);
                isMinYear = true;
            } else if (maxYearCondition) {
                year = maxYear + yearRangeMidpoint - (yearRangePosition * yearRangeShow) - yearRangeShow + 1;
                isMaxYear = true;
            }

            let years = Array.from({ length: yearRangeShow }, (v, k) => k + year - yearRangeMidpoint + (yearRangePosition * yearRangeShow));

            if (returnable == "json") {
                result.push({
                    range: `${years[0]} - ${years[years.length - 1]}`,
                    years: years,
                    isMinYear: isMinYear,
                    isMaxYear: isMaxYear,
                    calendar: this.calendar
                });
            } else {
                // console.log(template.years, this.parseTemplate);
                result += this.parseTemplate('selector-years', {
                    range: `${years[0]} - ${years[years.length - 1]}`,
                    years: years,
                    isMinYear: isMinYear,
                    isMaxYear: isMaxYear,
                    calendar: this.calendar,
                    this: this
                });
            }

            return result;
        }

        getConnectedCalendar() {
            let calendar = this.hasAttribute('calendar') ? document.querySelector(this.getAttribute('calendar')) : this.closest('simple-calendar');
            // console.log(calendar);
            return calendar;
        }

        getLocale(customLocale = false) {
            let locale = this.getAttribute('locale');
            // console.log(locale);
            return this.calendar.getLocale(locale ?? false);
        }

        getYear(customYear = false) {
            let year = this.getAttribute('year');
            if (customYear) { month = customYear; }
            return this.calendar.getYear(year ?? false);
        }

        getMonth(customMonth = false) {
            let month = this.getAttribute('month');
            if (customMonth) { month = customMonth; }
            return this.calendar.getMonth(month ?? false);
        }

        // getDay( customDay = false ) {
        //     let day = this.getAttribute('day');
        //     if ( customDay ) { day = customDay; }
        //     return this.calendar.getDay( day ?? false );
        // }

    }

    customElements.define('simple-calendar-selector', SimpleCalendarSelectorElement);

})();